<form class="padding-right-em-1-50 padding-top">
  <mat-form-field class="width-100">
    <mat-label i18n="@@store">Outlet</mat-label>
    <input
      type="text"
      placeholder="Select Outlet"
      i18n-placeholder="@@select-store"
      matInput
      [formControl]="outletForm"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="
        setOutlet($event.option.value);
        canVisit();
        redirectToDashboard($event.option.value)
      "
    >
      <mat-option
        *ngFor="let outletRight of filteredOutletRights | async"
        [value]="outletRight"
      >
        {{ outletRight.outlet.identity.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
